import script from "./AddProjectMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProjectMenu.vue?vue&type=script&setup=true&lang=js"

import "./AddProjectMenu.vue?vue&type=style&index=0&id=7f889567&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f889567"]])

export default __exports__